<div class="d-flex justify-content-center align-items-center flex-column">
  <p class="loader-title">
    {{ 'page.assignment_modal.loader.title' | translate }}
  </p>
  <img
    class="loading-image"
    src="assets/img/shift-timeline/timeline-modal-loader.gif"
    alt="Loading..."
  />
  <div class="row mb-2 content-1">
    <fa-icon [icon]="checkIcon" class="col-1 check-icon"></fa-icon>
    <span class="col-11 loader-content">
      {{ 'page.assignment_modal.loader.qualification' | translate }}
    </span>
  </div>

  <div class="row mb-2 content-2">
    <fa-icon [icon]="checkIcon" class="col-1 check-icon"></fa-icon>
    <span class="col-11 loader-content">
      {{ 'page.assignment_modal.loader.validation' | translate }}
    </span>
  </div>

  <div class="row mb-2 content-3">
    <fa-icon [icon]="checkIcon" class="col-1 check-icon"></fa-icon>
    <span class="col-11 loader-content">
      {{ 'page.assignment_modal.loader.smart_score' | translate }}
    </span>
  </div>

  <div class="row mb-2 content-4">
    <fa-icon [icon]="checkIcon" class="col-1 check-icon"></fa-icon>
    <span class="col-11 loader-content">
      {{ 'page.assignment_modal.loader.pref_score' | translate }}
    </span>
  </div>
</div>
